import { useState } from "react";
import type { CSSProperties, ReactNode } from "react";

interface NavSectionProps {
  title: string;
  icon?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

function NavSection({ title, icon, children, defaultOpen = true }: NavSectionProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const sectionStyle: CSSProperties = {
    marginBottom: "0.5rem",
  };

  const headerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "var(--color-text-muted)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    userSelect: "none",
    transition: "color 0.15s",
  };

  const contentStyle: CSSProperties = {
    maxHeight: isOpen ? "1000px" : "0",
    overflow: "hidden",
    transition: "max-height 0.2s ease-out",
  };

  return (
    <div style={sectionStyle}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          ...headerStyle,
          background: "none",
          border: "none",
          width: "100%",
          textAlign: "left",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "var(--color-text)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "var(--color-text-muted)";
        }}
      >
        <span style={{ fontSize: "0.875rem" }}>{isOpen ? "▼" : "▶"}</span>
        {icon && <span>{icon}</span>}
        <span>{title}</span>
      </button>
      <div style={contentStyle}>{children}</div>
    </div>
  );
}

export default NavSection;
